
class VideoImageTimeline {
  constructor(rootElement) {
    this.root = rootElement;

    this.navigationContainer = this.root.querySelector('[data-desktop-navigation');
    this.desktopNavButtons = this.navigationContainer.querySelectorAll('[data-navigation-button]');
    this.navigationOverlay = this.navigationContainer.querySelector('[data-navigation-overlay');
    this.allNavigationButtons = this.root.querySelectorAll('[data-navigation-button]')
    this.slides = this.root.querySelectorAll('[data-timeline-slide]');
    this.activeIndex = 0;

    this.allNavigationButtons.forEach(navBtn => {
      navBtn.addEventListener('click', this.handleNavClick.bind(this))
    });

    window.addEventListener('resize', this.handleResize.bind(this));
    this.handleResize()
  }

  get activeNavButtons() {
    return [...this.allNavigationButtons].filter(button => {
      return parseInt(button.dataset.index) === this.activeIndex;
    })
  }

  get inactiveNavButtons() {
    return [...this.allNavigationButtons].filter(button => {
      return parseInt(button.dataset.index) !== this.activeIndex;
    })
  }

  get activeSlide() {
    return [...this.slides].find(button => {
      return parseInt(button.dataset.index) === this.activeIndex;
    })
  }

  get activeVideo() {
    return this.activeSlide.querySelector('[data-slide-video]');
  }

  get inactiveVideos() {
    return this.inactiveSlides.map(slide => slide.querySelector('[data-slide-video]'))
      .filter(video => !!video);
  }

  get inactiveSlides() {
    return [...this.slides].filter(button => {
      return parseInt(button.dataset.index) !== this.activeIndex;
    })
  }

  degreesToRadians(degrees) {
    return degrees * (Math.PI / 180)
  }

  handleResize() {
    const graphicPath = this.navigationOverlay.querySelector('[data-graphic-path]');
    const pathLength = graphicPath.getTotalLength();
    const svg = graphicPath.closest('svg');
    
    // Get the SVG viewBox to understand the coordinate system
    const viewBox = svg.getAttribute('viewBox')?.split(' ') || ['0', '0', '200', '100'];
    const viewBoxWidth = parseFloat(viewBox[2]);
    const viewBoxHeight = parseFloat(viewBox[3]);
    
    // Get the actual rendered size of the SVG
    const svgRect = svg.getBoundingClientRect();
    const overlayRect = this.navigationOverlay.getBoundingClientRect();
    
    // Calculate scale factors to convert from SVG viewBox coordinates to screen coordinates
    const scaleX = svgRect.width / viewBoxWidth;
    const scaleY = svgRect.height / viewBoxHeight;
    
    // Get SVG position relative to overlay (for absolute positioning)
    const svgOffsetX = svgRect.left - overlayRect.left - 20;
    const svgOffsetY = svgRect.top - overlayRect.top + 20;

    this.desktopNavButtons.forEach((btn, index) => {
      // Calculate position along the path (0 = start, 1 = end)
      const t = this.desktopNavButtons.length > 1 ? index / (this.desktopNavButtons.length - 1) : 0;
      const pointAtLength = graphicPath.getPointAtLength(pathLength * t);
      
      // Convert SVG viewBox coordinates to screen coordinates relative to overlay
      // Note: yPos uses bottom positioning, so we need to invert it
      const xPos = svgOffsetX + (pointAtLength.x * scaleX) - 10;
      const yPos = overlayRect.height - 30 - (svgOffsetY + (pointAtLength.y * scaleY));

      btn.style.setProperty('--x-pos', `${xPos}px`);
      btn.style.setProperty('--y-pos', `${yPos}px`);
    })
  }

  handleNavClick(event) {
    const clickedBtn = event.target;
    const buttonIndex = parseInt(clickedBtn.dataset.index);
    this.activeIndex = buttonIndex;

    this.activeNavButtons.forEach(button => button.classList.add('is-active'));
    this.inactiveNavButtons.forEach(button => button.classList.remove('is-active'));

    this.activeSlide.classList.add('is-active');
    this.inactiveSlides.forEach(button => button.classList.remove('is-active'));

    this.activeVideo?.play();
    this.inactiveVideos.forEach(video => video.pause());

  }

}


function initVideoImageTimeline(root = document) {
  const timelines = root.querySelectorAll('[data-video-image-timeline]');
  timelines.forEach(timeline => new VideoImageTimeline(timeline));
}

document.addEventListener('DOMContentLoaded', () => {
  initVideoImageTimeline();
});

// Run on section load in Shopify theme editor
document.addEventListener('shopify:section:load', (event) => {
  initVideoImageTimeline(event.target); 
});